module.exports = __webpack_public_path__ + "img/gw-bill.e4d7b276.png";